function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import NumberFormat from 'react-number-format';
export function FormattedInputCurrency(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      name = props.name,
      other = _objectWithoutProperties(props, ["inputRef", "onChange", "name"]);

  return /*#__PURE__*/React.createElement(NumberFormat, Object.assign({}, other, {
    getInputRef: inputRef,
    decimalScale: 2,
    onValueChange: function onValueChange(values) {
      return onChange({
        target: {
          name: name,
          value: values.value
        }
      });
    },
    thousandSeparator: true,
    prefix: "$"
  }));
}
export default FormattedInputCurrency;